import { render, staticRenderFns } from "./EditNewsDynamic.vue?vue&type=template&id=61ac2848&scoped=true&"
import script from "./EditNewsDynamic.vue?vue&type=script&lang=js&"
export * from "./EditNewsDynamic.vue?vue&type=script&lang=js&"
import style0 from "./EditNewsDynamic.vue?vue&type=style&index=0&id=61ac2848&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac2848",
  null
  
)

export default component.exports